const autoNgTemplateLoaderTemplate1 = require('./supplement-list.template.html');

'use strict';

import { NAVIGATION_ICON } from '../../modules/shared/constants/system/navigationIcons';
import { SOLUTION_TYPE } from '../../modules/shared/constants/user-info/solutionType';

(function () {
    angular
        .module('app.supplementList', [])
        .config(supplementListConfig);

    supplementListConfig.$inject = ['$routeProvider'];

    function supplementListConfig($routeProvider) {
        $routeProvider
            .when('/supplement-customers-list', {
                disableCache: true,
                templateUrl: autoNgTemplateLoaderTemplate1,
                controller: 'SupplementListController',
                controllerAs: 'vm',
                reloadOnSearch: false,
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                },
                pageConfig: {
                    solution: SOLUTION_TYPE.NUTRITION,
                    breadcrumbs: [
                        { label: 'Supplement Users', icon: NAVIGATION_ICON.LIST_ALT }
                    ]
                }
            })
    }
})();
